// src/contexts/AuthContext.js
import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => {
    // Initialize from sessionStorage if available
    const token = sessionStorage.getItem("usertoken");
    const userType = sessionStorage.getItem("usertype");
    return {
      isAuthenticated: !!token,
      userType: userType || null,
      token: token || null
    };
  });

  const login = (userData) => {
    if(userData.user_type==='staff'|| userData.user_type==='sales_admin' || userData.user_type==='config_admin') {
    sessionStorage.setItem("usertoken", userData.token);
    sessionStorage.setItem("usertype", userData.userType);
    sessionStorage.setItem("name", userData.name);
    sessionStorage.setItem("user_type", userData.user_type);
    sessionStorage.setItem("header_alegra", userData.header_alegra);
    setAuth({
      isAuthenticated: true,
      userType: userData.userType,
      token: userData.token
    });
  }
  };

  const logout = () => {
    sessionStorage.removeItem("usertoken");
    sessionStorage.removeItem("usertype");
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("user_type");
    sessionStorage.removeItem("header_alegra");
    setAuth({
      isAuthenticated: false,
      userType: null,
      token: null
    });
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}